export const PAGE_PATH = {
    HOME: "/",
    RESOURCES: "/Resources",
    ROUND: "/Round",
    ADMIN: "/Admin",
};

export const LANGUAGE = {
    ENGLISH: "EN",
    SPANISH: "ES",
};

export const ALERT_LEVEL = {
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
};

export const HTTP_METHOD = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
};

export const ACTIONS = {
    LOADING: "LOADING",
    CLEAR_LOADING: "CLEAR_LOADING",
    ERROR: "ERROR",
    REPORT_ERROR: "REPORT_ERROR",
    CLEAR_ERROR: "CLEAR_ERROR",
    API: "API",
};

export const ERROR = {
    UNDEFINED: "UNDEFINED",
    UNAUTHORIZED: "UNAUTHORIZED",
    BAD_REQUEST: "BAD_REQUEST",
    MAINTENANCE_MODE: "MAINTENANCE_MODE",
    HIGH_TRAFFIC: "HIGH_TRAFFIC",
};

export const APP_SETTINGS = {
    
};